import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import doctorAPI from '../../sources/api/doctorAPI';

// constants
import { DOCTOR_CREATE, DOCTOR_LIST_FETCH } from '../../constants/doctorTypes';

// lib
import handleServerValidation from '../../lib/handleServerValidation';
import httpSaga from '../../lib/httpSaga';

// schemas
import { doctorListSchema } from '../../schemas/Normalizr';
import { tooltipHide } from '../../actions/tooltipActions';
import {
  DOCTOR_CREATE_SUCCESS,
  DOCTOR_CREATE_ERROR
} from '../../constants/messages';
import { toastr } from 'react-redux-toastr';

export function* doctorCreate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const page    = yield select((state) => state.get('doctor').get('page'));
  const params  = action.payload;

  params.currentWeeklySchedule = {
    monday: params.inOfficeMonday,
    tuesday: params.inOfficeTuesday,
    wednesday: params.inOfficeWednesday,
    thursday: params.inOfficeThursday,
    friday: params.inOfficeFriday
  };

  try {
    yield *httpSaga(DOCTOR_CREATE, call(doctorAPI.create, params));
    yield *httpSaga(DOCTOR_LIST_FETCH, call(doctorAPI.all, page), doctorListSchema);
    yield put(tooltipHide({ id: params.tooltipId }));
    yield toastr.success('success', DOCTOR_CREATE_SUCCESS);
  } catch (e) {
    const body    = (e.response || {}).body || {};
    const errors  = handleServerValidation('doctor', body.details, { nestedPath: true });

    yield toastr.error(DOCTOR_CREATE_ERROR);
    yield put(error(DOCTOR_CREATE, errors));
  } finally {
    yield put(doneIndicator(DOCTOR_CREATE));
  }
}

export function* watchDoctorCreate() {
  yield takeEvery(DOCTOR_CREATE, doctorCreate);
}

export default function* root() {
  yield all([
    fork(watchDoctorCreate)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/doctor/doctorCreate.js